import { KEYS } from "./constants-keys";

const AppConfig = {
  KEYS,
};
export default AppConfig;
